import {jsonRpc} from '@communication'


export default function useRepository () {
  const sendWsEvent = jsonRpc.sendRepositoryEvent
  const sendStats = jsonRpc.sendStats

  return {
    sendWsEvent,
    sendStats,
  }
}
